export default __webpack_public_path__ + "static/media/undraw_security_o890.8a7cafcb.svg";